import React from "react";
// import Mainlogo from "../assets/images/first-page/main-logo.svg";
// import Bottomright from "../assets/images/first-page/bottom-right-gradient.svg";
// import Topleft from "../assets/images/first-page/top-left-gradient.svg";
// import {
//   TextField,
//   Button,
//   IconButton,
//   Typography,
//   Box,
//   FormControl,
//   InputLabel,
//   OutlinedInput,
//   InputAdornment,
//   Stack,
// } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBarComponents from "./landingPageComponents/components/NavBar";
import TrustedBySection from "./landingPageComponents/components/TrustedBySection";
import FooterComponents from "./landingPageComponents/components/Footer";
import HeroSectionComponents from "./landingPageComponents/components/HeroSection";
import ModelsSectionComponent from "./landingPageComponents/components/ModelsSection";
import HowItWorksSectionComponent from "./landingPageComponents/components/HowItWorksSection";
import FeaturesSectionComponent from "./landingPageComponents/components/FeaturesSection";
import ContactSection from "./landingPageComponents/components/ContactSection";
import TestimonialsSectionComponent from "./landingPageComponents/components/TestimonialsSection";
import PricingSectionComponent from "./landingPageComponents/components/PricingSection";
import "../assets/css/landingPageCustom.css";

function LandingPage() {
  // const navigate = useNavigate(); // Initialize navigation

  // useEffect(() => {
  //   // Navigate to login after 3 seconds
  //   const timer = setTimeout(() => {
  //     navigate("/login");
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, [navigate]);
  return (
    // <Box className="front-page" sx={{ position: "relative" }}>
    //   <Stack
    //     justifyContent={"center"}
    //     alignItems={"center"}
    //     sx={{ height: "100%" }}
    //   >
    //     <img src={Mainlogo} alt="main-logo" />
    //     <Typography
    //       variant="h1"
    //       sx={{ color: "#fff", fontSize: "48px", fontWeight: "700", mt: "8px" }}
    //       fullWidth
    //     >
    //       Asklms
    //     </Typography>
    //   </Stack>
    //   <Box sx={{ position: "absolute", top: 0, left: 0 }}>
    //     <img src={Topleft} alt="gradient" />
    //   </Box>
    //   <Box sx={{ position: "absolute", bottom: 0, right: 0 }}>
    //     <img src={Bottomright} alt="gradient" />
    //   </Box>
    // </Box>

    <div className="App custom-font">
      <NavBarComponents />
      <main>
        <HeroSectionComponents />
        {/* <TrustedBySection /> */}
        <ModelsSectionComponent />
        <HowItWorksSectionComponent />
        <FeaturesSectionComponent />
        {/* <TestimonialsSectionComponent /> */}
        {/* <PricingSectionComponent /> */}
        <ContactSection />
      </main>
      <FooterComponents />
    </div>
  );
}

export default LandingPage;
